<template>
  <div>
    <el-card class="box-card" body-style="min-height:90vh;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="系统配置" name="first">
          <management-system v-if="isManagement"></management-system>
          <shop-system v-else-if="isShop"></shop-system>
        </el-tab-pane>
        <el-tab-pane v-if="isManagement" label="协议配置" name="privacy">
          <privacy></privacy>
        </el-tab-pane>
        <template v-if="isShop">
          <el-tab-pane label="会员配置" name="third">
            <vip></vip>
          </el-tab-pane>
          <el-tab-pane label="商品配置" name="forth">
            <goods-explain></goods-explain>
          </el-tab-pane>
          <el-tab-pane label="背景图配置" name="fifth">
            <bg-img></bg-img>
          </el-tab-pane>
          <el-tab-pane label="微信支付配置" name="sixth">
            <wx-pay></wx-pay>
          </el-tab-pane>
          <el-tab-pane label="自提核销配置" name="seventh">
            <write-off></write-off>
          </el-tab-pane>
          <el-tab-pane label="发票配置" name="eighth">
            <invoice></invoice>
          </el-tab-pane>
          <el-tab-pane label="分销配置" name="nighth">
            <distribution></distribution>
          </el-tab-pane>
        </template>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import ManagementSystem from './components/ManagementSystem.vue'
import ShopSystem from './components/ShopSystem.vue'
import Privacy from './components/Privacy.vue'
import Vip from './components/Vip.vue'
import GoodsExplain from './components/GoodsExplain.vue'
import BgImg from './components/BgImg.vue'
import WxPay from './components/WxPay.vue'
import WriteOff from './components/WriteOff.vue'
import Invoice from './components/Invoice.vue'
import Distribution from './components/Distribution.vue'
import { isShopLogin, isManagementLogin } from '@/utils/auth'
export default {
  name: 'Setting',
  components: {
    ManagementSystem,
    ShopSystem,
    Privacy,
    Vip,
    GoodsExplain,
    BgImg,
    WxPay,
    WriteOff,
    Invoice,
    Distribution
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      activeName: 'first',
      activeNum: 1
    }
  },
  computed: {
    isShop () {
      return isShopLogin()
    },
    isManagement () {
      return isManagementLogin()
    }
  },
  methods: {
    handleClick (tab) {
      if (tab.name === 'first') {
        this.activeNum = 1
      } else if (tab.name === 'privacy') {
        this.activeNum = 0
      } else if (tab.name === 'third') {
        this.activeNum = 2
      } else if (tab.name === 'forth') {
        this.activeNum = 3
      } else if (tab.name === 'fifth') {
        this.activeNum = 4
      } else if (tab.name === 'sixth') {
        this.activeNum = 5
      } else {
        this.activeNum = 6
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/Setting.vue